var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFred(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-.004 0H9.46v2.914H3.275v2.04h5.593v2.76H3.275V12H-.004V0zM10.401 0h5.594c1.808 0 3.058.48 3.853 1.303.692.686 1.047 1.611 1.047 2.794v.034c0 1.835-.963 3.052-2.433 3.686L21.284 12h-3.786l-2.382-3.634h-1.437V12h-3.278V0zm5.441 5.76c1.116 0 1.758-.549 1.758-1.423v-.034c0-.943-.676-1.423-1.774-1.423H13.68v2.88h2.162zM22.012 0h9.514v2.829h-6.27v1.816h5.678v2.623h-5.678v1.903h6.354V12h-9.598V0zM32.762 0h4.563C41.55 0 44 2.468 44 5.931v.035C44 9.429 41.517 12 37.258 12h-4.496V0zm4.613 9.051c1.96 0 3.262-1.097 3.262-3.034v-.034c0-1.92-1.302-3.034-3.262-3.034H36.04V9.05h1.335z",
    fill: "currentColor"
  })));
}
export default SvgFred;